import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { Button, Dropdown, Icon } from "@kyan/ui";
import { useState } from "react";

import { PortfolioAccountDropdown } from "#/app/(desktop)/portfolio/components/PortfolioAccountDropdown/PortfolioAccountDropdown";
import { Divider } from "#/components/Divider/Divider";
import { ThemeSwitcher } from "#/components/ThemeSwitcher/ThemeSwitcher";
import { useWalletButtonFeatureFlag } from "#/hooks/featureFlags/useWalletButtonFeatureFlag";
import { useHandleLogIn } from "#/hooks/useHandleLogIn";

import { Disconnect } from "./components/Disconnect";
import { Navbar } from "./components/Navbar";
import { NetworkAndWallet } from "./components/NetworkAndWallet";
import { OneClickTradingModal } from "./components/OneClickTradingModal";

export const Menu: React.FC = () => {
  const { handleLogIn } = useHandleLogIn();
  const { primaryWallet } = useDynamicContext();
  const walletButtonFlag = useWalletButtonFeatureFlag();

  const [isOpen, setIsOpen] = useState(false);

  const isDisabledByFeatureFlag = !walletButtonFlag?.isEnabled;
  const defaultLabel = "Connect";

  if (!primaryWallet) {
    return (
      <Button
        className="mr-4"
        disabled={isDisabledByFeatureFlag}
        onClick={handleLogIn}
      >
        {isDisabledByFeatureFlag
          ? (walletButtonFlag?.title ?? defaultLabel)
          : defaultLabel}
      </Button>
    );
  }

  return (
    <Dropdown
      align="end"
      open={isOpen}
      sideOffset={24}
      trigger={
        <button className="grid size-8 place-items-center">
          <Icon
            name="menu"
            hoverEffect="square"
            className="bg-buttonFill text-textPrimary"
          />
        </button>
      }
      onOpenChange={setIsOpen}
    >
      <div className="bg-background border-divider grid gap-4 rounded-sm border p-3 shadow-md">
        <PortfolioAccountDropdown className="w-full" />
        <OneClickTradingModal />
        <Navbar
          handleCloseMenu={() => {
            setIsOpen(false);
          }}
        />
        <ThemeSwitcher showLabel={false} />
        <Divider />
        <NetworkAndWallet />
        <Disconnect />
      </div>
    </Dropdown>
  );
};
